import styled from "styled-components";

import { ConsolePageSelectContainer } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageSelect/styles";

export const MiniRankingContainer = styled.div`
  padding-bottom: 3rem;

  .title-options {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 0.75rem;
    gap: 0.25rem;

    @media (max-width: 1400px) {
      flex-direction: column;
    }

    .title {
      font: 500 0.813rem/1.219rem "Inter";
      margin-bottom: 0;
      width: 100%;
    }

    ${ConsolePageSelectContainer} {
      button {
        background-color: transparent;
        border: none !important;
        padding: 0;
      }
    }
  }

  .values-wrapper .value {
    font-weight: 500 !important;
  }

  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 1rem;

    padding: 12px;
    border-radius: 4px;

    border: 1px solid
      ${({ theme }) => theme.classwork.imersive.dropdownBorderColor};
    background-color: ${({ theme }) =>
      theme.classwork.imersive.bluredBackgroundColor};
    backdrop-filter: blur(10px);

    @media (max-width: 1400px) {
      justify-content: space-between;
    }
  }

  .podium-section {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: 0.75rem;
    width: 100%;
  }

  .podium {
    display: flex;
    flex-direction: column;
    width: 5.333rem;

    @media (max-width: 1400px) {
      width: 3.333rem;
    }
  }

  svg.podium-top {
    width: min-content;
    position: relative;
    top: 1px;
    left: -1px;

    @media (max-width: 1400px) {
      top: 3px;
      width: 52px;
    }
  }

  .ranking-item {
    display: flex;
    flex-direction: column;
    align-items: center;

    .position {
      width: 27px;
      height: 27px;

      @media (max-width: 1400px) {
        font-size: 0.7125rem;
      }
    }

    .name {
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;

      text-align: center;

      @media (max-width: 1400px) {
        max-width: 6ch;
      }
    }

    .exp {
      white-space: nowrap;
    }
  }

  a {
    cursor: pointer;
    width: 100%;
  }
`;

export const CustomButton = styled.button`
  cursor: pointer;
  background-color: ${({ theme }) =>
    theme?.classwork?.imersive.buttonBackgroundColor};
  padding: 0.5rem;
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.groups.primaryText};
  width: 100%;
  font: 500 0.813rem/1.219rem "Inter";
`;
